'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeStealthForceChart', require('./stealthforcechart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/forcechart/index.js
 **/